/**
 * Where a "buy" click goes. The Essential tier's checkout mounts Stripe on
 * load, so a reader lands on a payment form rather than on the store front
 * page needing to pick a tier first. Anything that is NOT purchase intent —
 * the changelog's "download your copy", the API base URL — keeps pointing at
 * the site root.
 */
export const CHECKOUT_URL = "https://buy.multiagentbook.com/checkout/essential";

/**
 * The site's primary destinations, in nav order, defined once.
 *
 * The header renders these with icons and a dropdown, and the 404 offers them
 * as ways out. Keeping a second hand-written copy on the 404 is how the two
 * quietly drift apart, so both read this.
 *
 * Labels are i18n keys, not strings, because the header is already translated
 * into six languages and the 404 must not be the one English page.
 */
export interface SiteLink {
  /** i18n key in the `common` namespace. */
  labelKey: string
  /** Fallback if the key is missing, so a bad key degrades to English. */
  label: string
  href: string
  isExternal?: boolean
  /** A line of context on the 404, where a bare label is thin. */
  noteKey?: string
  note?: string
}

export const siteLinks: SiteLink[] = [
  { labelKey: "nav.labs", label: "Labs", href: "/labs",
    note: "comparisons, use cases and data" },
  { labelKey: "nav.news", label: "News", href: "/news",
    note: "what shipped this week" },
  { labelKey: "nav.buy", label: "Buy", href: CHECKOUT_URL, isExternal: true,
    note: "digital formats, lifetime updates" },
]

/** The home page, kept out of `siteLinks` because the logo already links there. */
export const homeLink: SiteLink = { labelKey: "nav.home", label: "Home", href: "/" }
